import { BodyPrimary, H2 } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { Close } from '@liveauctioneers/hammer-ui-core/icons';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';
import isEqual from 'react-fast-compare';
import styled from 'styled-components';

import ItemSaveContainer from '@/components/ItemSave/ItemSaveContainer';

type Props = {
    currentImageIndex: number;
    galleryLength: number;
    galleryTitle: string;
    itemId: number;
    onClose: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const LightboxHeader = ({ currentImageIndex, galleryLength, galleryTitle, itemId, onClose }: Props) => {
    const { formatMessage } = useIntl();

    return (
        <>
            {/* Header content */}
            <HeaderContainer>
                <ContentContainer>
                    <H2>{galleryTitle}</H2>
                    <IconButton
                        icon={Close}
                        onClick={onClose}
                    />
                </ContentContainer>
            </HeaderContainer>
            {/* Relative pagination and favorite button container */}
            <PaginationOverlay>
                {/* Absolute container */}
                <OverlayContainer>
                    <ImageIndexCounter>
                        <BodyPrimary>
                            {formatMessage(
                                { id: 'lightbox.header' },
                                {
                                    currentImage: currentImageIndex + 1,
                                    galleryLength,
                                }
                            )}
                        </BodyPrimary>
                    </ImageIndexCounter>
                    <ItemSaveContainer itemId={itemId} />
                </OverlayContainer>
            </PaginationOverlay>
        </>
    );
};

export default React.memo<Props>(LightboxHeader, isEqual);

const HeaderContainer = styled.header`
    background-color: ${({ theme }) => theme.colors.grey500};
    padding: 10px 20px;
    z-index: 10;
    user-select: none;
`;

const ContentContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const ImageIndexCounter = styled.div`
    padding: 3px 12px;
    opacity: 0.85;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.grey100};
    display: flex;
    align-items: center;
    justify-content: center;

    /** I needed white primary but it doesn't exist so here we are */
    span {
        color: ${({ theme }) => theme.colors.white};
    }
`;

const PaginationOverlay = styled.div`
    position: relative;
`;

const OverlayContainer = styled.div`
    position: absolute;
    right: 0;
    left: 0;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > * {
        z-index: 10;
    }
`;
